/**
 * App Light Theme
 */
import {createMuiTheme} from '@material-ui/core/styles';
import AppConfig from '../../config/AppConfig';
import overrideStyles from './overrideStyles';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: AppConfig.themeColors.primary,
        },
        secondary: {
            main: AppConfig.themeColors.warning,
        },
    },
    typography: {
        useNextVariants: true,
        //suppressDeprecationWarnings: true,
        // Use the system font instead of the default Roboto font.
        fontFamily: ['Roboto', 'Helvetica', 'Arial', 'Heebo', 'sans-serif'].join(','),
    },
    overrides: {
        ...overrideStyles,
    },
});

export default theme;
